/**
 * 0xGG Team
 * Distributed under AGPL3
 *
 * DESCRIPTION: Inline code fold that aims to get VickyWidgets work `@appname arg1=val1 arg2=val2`
 */

(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, require("./fold"), require("../widget/index"), require("../widget/hello/hello"), require("../widget/error/error")) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports","./fold","../widget/index","../widget/hello/hello","../widget/error/error"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.FoldWidget = this.HyperMD.FoldWidget || {}), HyperMD.Fold, HyperMD.Widget, HyperMD.WidgetHello, HyperMD.WidgetError);
})(function (require, exports, fold_1, index_1, hello_1, error_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WidgetFolder = void 0;
    index_1.registerWidgetCreator("hello", hello_1.HelloWidget);
    index_1.registerWidgetCreator("error", error_1.ErrorWidget);
    exports.WidgetFolder = function (stream, token) {
        if (!token.type ||
            token.type.indexOf("comment") < 0 ||
            !token.string.trim().match(/^<!--\s*@/) ||
            !token.string.trim().match(/-->$/)) {
            return null;
        }
        var start = token.start;
        var end = token.end;
        var cm = stream.cm;
        var str = token.string
            .replace(/^<!--\s*/, "")
            .replace(/-->$/, "")
            .trim();
        var widgetName;
        var widgetAttributes = {};
        var firstSpaceMatch = str.match(/\s/);
        var firstSpace = firstSpaceMatch ? firstSpaceMatch.index : -1;
        if (firstSpace > 0) {
            widgetName = str.slice(0, firstSpace).trim().replace(/^@/, "");
            try {
                var j = str.slice(firstSpace + 1).trim();
                if (j[0] === "{") {
                    widgetAttributes = JSON.parse(j
                        .replace(/-\\->/g, "-->")
                        .replace(/<!\\--/g, "<!--")
                        .replace(/\\\|/g, "|"));
                }
                else {
                    widgetAttributes = JSON.parse("{" +
                        j
                            .replace(/-\\->/g, "-->")
                            .replace(/<!\\--/g, "<!--")
                            .replace(/\\\|/g, "|") +
                        "}");
                }
            }
            catch (error) {
                widgetName = "error";
                widgetAttributes = { message: error.toString() };
            }
        }
        else {
            widgetName = str.trim().replace(/^@/, "");
        }
        if (!widgetName) {
            return null;
        }
        /*
        console.log("stream: ", stream);
        console.log("token: ", token);
        console.log("str: ", str);
        console.log("widgetName: ", widgetName);
        console.log("widgetAttributes: ", widgetAttributes);
        */
        var from = { line: stream.lineNo, ch: start };
        var to = { line: stream.lineNo, ch: end };
        var reqAns = stream.requestRange(from, to);
        if (reqAns !== fold_1.RequestRangeResult.OK)
            return null;
        var marker = null;
        var setAttributes = function (attributes) {
            var editor = cm;
            if (!editor || !marker) {
                return;
            }
            var pos = marker.find();
            if (!pos) {
                return;
            }
            var widgetFrom = pos.from;
            var widgetTo = pos.to;
            var line = editor.getLine(widgetFrom.line);
            if (!line) {
                throw new Error("Failed to update widget attributes");
            }
            var widgetName = line
                .slice(widgetFrom.ch, widgetTo.ch)
                .match(/\@[^\s$`]+/)[0];
            var attributesStr = JSON.stringify(attributes);
            editor.replaceRange(("<!-- " + widgetName + " " + attributesStr
                .replace(/^{/, "")
                .replace(/}$/, "")
                .replace(/-->/g, "-\\->")
                .replace(/<!--/g, "<!\\--") + " -->").replace(/\|/g, "\\|"), widgetFrom, widgetTo);
        };
        var replaceSelf = function (inputString) {
            var editor = cm;
            if (!editor || !marker) {
                return;
            }
            var pos = marker.find();
            if (!pos) {
                return;
            }
            var widgetFrom = pos.from;
            var widgetTo = pos.to;
            var line = editor.getLine(widgetFrom.line);
            if (!line) {
                throw new Error("Failed to update widget attributes");
            }
            editor.replaceRange(inputString, widgetFrom, widgetTo);
            editor.focus();
        };
        var removeSelf = function () {
            return replaceSelf("");
        };
        // Create the widget
        var widget;
        var widgetCreator = index_1.getWidgetCreator(widgetName);
        if (!widgetCreator) {
            return false;
        }
        else {
            widget = widgetCreator({
                editor: cm,
                attributes: widgetAttributes,
                setAttributes: setAttributes,
                removeSelf: removeSelf,
                replaceSelf: replaceSelf,
                isPreview: false,
            });
        }
        // Create widget here
        marker = cm.markText(from, to, {
            replacedWith: widget,
            collapsed: true,
            inclusiveLeft: true,
            inclusiveRight: true,
        });
        /*
        // 1 here means `
        widget.addEventListener("click", () => {
          breakMark(cm, marker, 1), false;
        });
        */
        return marker;
    };
    fold_1.registerFolder("widget", exports.WidgetFolder, true);
});
/*
example widget:

    `@timer "date":"Tue Dec 10 2019 10:54:07 GMT+0800 (China Standard Time)"`
*/
